import { ScheduledCallsForMentorRequest } from './../../models/calendly/scheduledCallsForMentorRequest';
import { Observable } from 'rxjs';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { apiResponse } from '../../models/apiResponse';
import { ScheduledCallsForMentorResponse } from '../../models/calendly/scheduledCallsForMentorResponse';
import { ScheduledMeetingResponse } from '../../models/calendly/ScheduledMeetingResponse';
import { ScheduledCallsForStudentResponse } from '../../models/calendly/scheduledCallsForStudentResponse';
import { Subject } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class CalendlyService {

  constructor(private genericService:GenericService) {

   }

   schduledMeetingForStudent$ = new Subject<ScheduledCallsForStudentResponse>();
   schduledMeetingForMentor$ = new Subject<ScheduledMeetingResponse>();

   canceledMeetingForStudent$ = new Subject<ScheduledCallsForStudentResponse>();
   canceledMeetingForMentor$ = new Subject<ScheduledMeetingResponse>();

   reSchduledMeetingForStudent$ = new Subject<ScheduledCallsForStudentResponse>();
   reSchduledMeetingForMentor$ = new Subject<ScheduledMeetingResponse>();

   isIntegrationExists(): Observable<boolean>{
    return this.genericService.get(`calendly/integrationexists`);
   }

   getAuthUrl(): Observable<string>{
    return this.genericService.get(`calendly/auth`);
   }

   saveIntegrationStatus(code:string): Observable<string>{
    return this.genericService.post(`calendly/integrate`,{authorizationCode:code});
   }

   getScheduledMeeting(request:ScheduledCallsForMentorRequest):Observable<apiResponse<ScheduledCallsForMentorResponse[]>>
   {
      return this.genericService.post(`calendly/getscheduledcallsformentor`,request);
   }

   getMeetings(mentorId:string):Observable<apiResponse<ScheduledMeetingResponse[]>>
   {
      return this.genericService.get(`calendly/meetings/${mentorId}`);
   }

   getStudentMeetings():Observable<apiResponse<ScheduledCallsForStudentResponse[]>>
   {
      return this.genericService.get(`calendly/getscheduledcallsforstudent`);
   }
}
